import { useExistingShipFromRequiresEmail } from '../../hooks/use-requires-email';
import { INLINE_MESSAGE_TYPES } from 'ui-components/components/inline-message';
import { ORIGIN_ADDRESS, RETURN_ADDRESS, REQUIRES_EMAIL } from './constants';
import { shipFromDropdownSchema } from './schema';
import { generateAddressFormattedMessage } from './messages';
import { useYupFormValidation } from '../../../validation/use-yup-form-validation';

export const useShipFromValidation = ({ selectedShipFromId, shipFroms, selectedLabelProviderId, showError = true }) => {
  const selectedShipFrom = shipFroms?.find(({ shipFromId }) => shipFromId === selectedShipFromId) || undefined;
  const { errors } = useYupFormValidation({
    form: selectedShipFrom,
    schema: shipFromDropdownSchema,
  });
  const emailIsRequired = useExistingShipFromRequiresEmail(selectedShipFrom ? [selectedShipFrom] : [], selectedLabelProviderId, showError);
  const error = (Object.keys(errors).length > 0 && (errors?.[ORIGIN_ADDRESS] || errors?.[RETURN_ADDRESS])) || emailIsRequired;
  const emailErrorMessage = generateAddressFormattedMessage(REQUIRES_EMAIL);
  return {
    ...(error &&
      selectedShipFromId &&
      selectedShipFrom && {
        helperText: error.message || emailErrorMessage,
        helperTextType: INLINE_MESSAGE_TYPES.error,
      }),
  };
};
